<template>
  <screen
    v-show="show"
    :screen-name="$t('tutorial.title')"
    :screen-info="$t('tutorial.clench_fingers')"
    @skip="$emit('skip')"
  >
    <circle-window>
      <clench-finger :isRelax="false" />
    </circle-window>
  </screen>
</template>

<script>
import autoNext from '../../mixins/auto-next';

import Screen from '../common/Screen.vue';
import CircleWindow from './CircleWindow.vue';
import ClenchFinger from './ClenchFinger.vue';

export default {
  name: 'ClenchFingers2',
  components: {
    Screen,
    CircleWindow,
    ClenchFinger,
  },
  mixins: [autoNext],
  data: () => ({
    duration: 3.5,
  }),
};
</script>
